export default __webpack_public_path__ + "static/media/story_image.27eb3dd6.png";